import * as types from '../mutations-types'

// initial state
const state = {
  emailKeyword: ''
}

// mutations
const mutations = {
  [types.EMAIL_KEYWORD](state, emailKeyword) {
    state.emailKeyword = emailKeyword
  }
}

export default {
  state,
  mutations
}
